<form [formGroup]="formAddSubscription" (ngSubmit)="onAddSubscriptionSubmit()">
  <div class="formgrid grid p-fluid">
    <div class="field col-12">
      <p class="font-normal text-600 m-0">
        <span class="text-primary font-medium">TAKE NOTE:</span> This adds a genuine second (or
        further) line to this customer on their existing account - it does not replace or cancel
        any subscription they already have.
      </p>
    </div>

    <div class="field col-12 md:col-6">
      <label for="portal_product_id">Package</label>
      <p-dropdown
        id="portal_product_id"
        formControlName="portal_product_id"
        [options]="products"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        [disabled]="isLoadingProducts"
        appendTo="body"
        placeholder="Select a package"
        emptyMessage="No packages found"
        class="w-full"
      ></p-dropdown>
      <small
        class="p-error"
        *ngIf="f['portal_product_id'].invalid && f['portal_product_id'].touched"
        >Please select a package</small
      >
    </div>

    <div class="field col-12 md:col-6">
      <label for="preferred_payment_method">Preferred Payment Method</label>
      <p-dropdown
        id="preferred_payment_method"
        formControlName="preferred_payment_method"
        [options]="paymentMethodOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        class="w-full"
      ></p-dropdown>
    </div>

    <div class="field col-12 md:col-6">
      <label for="promotion_code">Promotion Code (optional)</label>
      <input id="promotion_code" type="text" pInputText formControlName="promotion_code" class="w-full" />
    </div>

    <div class="field col-12 md:col-6">
      <label for="referral_code">Referral Code (optional)</label>
      <input id="referral_code" type="text" pInputText formControlName="referral_code" class="w-full" />
    </div>

    <div class="field col-12">
      <label for="device_reference">Existing Circuit / Device Reference (optional)</label>
      <input
        id="device_reference"
        type="text"
        pInputText
        formControlName="device_reference"
        placeholder="Circuit number or device serial"
        class="w-full"
      />
      <small class="text-600 block mt-1">
        If this customer already has a circuit installed (e.g. from a field install or TOC
        submission that hasn't been linked to a subscription yet), enter its circuit number or
        the device's serial number here. This line will be linked to it and activated
        immediately instead of starting a new signup, and will use that circuit's own number as
        its account reference (rather than generating a new one). Leave blank for a normal new
        line.
      </small>
    </div>

    <div class="field col-12 flex align-items-center gap-2">
      <p-checkbox
        formControlName="billing_auto_renew"
        [binary]="true"
        inputId="billing_auto_renew"
      ></p-checkbox>
      <label for="billing_auto_renew" class="m-0">Billing auto-renews</label>
    </div>

    <div class="field col-12">
      <button
        pButton
        type="submit"
        label="Add Subscription"
        class="p-button p-button-success"
        [loading]="submitting"
      ></button>
    </div>

    <div class="field col-12">
      <p-message
        *ngIf="errorMessage !== ''"
        severity="error"
        [text]="errorMessage"
        class="w-full"
      ></p-message>
    </div>
  </div>
</form>
